
import type { ReactNode } from 'react'

type TitleTag =
  | 'h1'
  | 'h2'
  | 'h3'
  | 'h4'
  | 'h5'
  | 'h6'

type ContentTag =
  | 'p'
  | 'span'
  | 'div'

interface TitlecontentProps {
  title: ReactNode
  content?: ReactNode
  textcolor?: string
  titleTag?: TitleTag
  contentTag?: ContentTag
}

function Titlecontent({
  title,
  content,
  textcolor = 'text-black',
  titleTag = 'h2',
  contentTag = 'p',
}: TitlecontentProps) {
  const TitleTag = titleTag
  const ContentTag = contentTag

  return (
    <div className={textcolor}>
      <TitleTag className="font-bold text-[22px] md:text-[26px] lg:text-[30px] xl:text-[36px] 2xl:text-[40px]">
        {title}
      </TitleTag>

      {content && (
        <ContentTag className="font-normal text-base xl:text-[18px] mt-6">
          {content}
        </ContentTag>
      )}
    </div>
  )
}

export default Titlecontent

